import type { ClaimState } from '../lib/claimState.js';
import styles from './StatusBadge.module.css';

const LABELS: Record<ClaimState, string> = {
  unclaimed: 'Claim',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
};

export function StatusBadge({ state }: { state: ClaimState }) {
  return <span className={`${styles.badge} ${styles[state]}`}>{LABELS[state]}</span>;
}
